import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/components/seo";
import { pageMeta, industries } from "@/content";
import { PlaceholderPage } from "@/components/placeholder-page";

export const Route = createFileRoute("/industries/")({
  head: () => routeHead("/industries"),
  component: IndustriesIndex,
});
function IndustriesIndex() {
  const p = pageMeta("/industries")!;
  return (
    <PlaceholderPage
      eyebrow="Industries"
      heading={p.h1}
      description={p.description}
      items={industries.map((i) => ({ label: i.name, href: i.href, summary: i.summary }))}
    />
  );
}
